import { StyleRoot } from "@redotech/react-util/style";
import { ConciergeProductFormSettings } from "@redotech/redo-model/concierge-product-form/concierge-product-form";
import { ShopifyAjaxClient } from "@redotech/shopify-client/ajax";
import { createRoot } from "react-dom/client";
import { AuthenticatedShopifyExtensionClientProvider } from "../client/authenticated-client-context";
import { RedoShopifyRpcClientContextProvider } from "../client/redo-shopify-rpc-client";
import { log } from "../monitoring/log";
import { RedoRoot } from "../root";
import { ExtensionShopifyClientContext } from "../shopify";
import STYLE_MANAGER from "../style-manager";
import { ConciergeProductFormShopifyWrapper } from "./product-form-shopify-wrapper";

export const CONCIERGE_PRODUCT_FORM_CONTAINER_ID =
  "redo-concierge-product-form-target";

export function initialize({
  fromThemeExtension,
  autocheckSettings,
}: {
  fromThemeExtension: boolean;
  autocheckSettings?: ConciergeProductFormSettings;
}) {
  log("Initializing Concierge product form");
  const container = document.getElementById(
    CONCIERGE_PRODUCT_FORM_CONTAINER_ID,
  );

  if (!container) {
    return;
  }

  const settings = (
    "conciergeProductFormSettings" in window
      ? window.conciergeProductFormSettings
      : autocheckSettings
  ) as ConciergeProductFormSettings | undefined;
  if (!settings) {
    return;
  }

  if (fromThemeExtension) {
    settings.addVerticalPadding = true;

    // Shopify applies display: none to empty divs
    container.style.display = "unset";
  }

  const root = createRoot(container);

  root.render(
    <StyleRoot container={container} styleManager={STYLE_MANAGER}>
      <RedoRoot
        extensionShopifyClient={undefined}
        storeUrl={
          globalThis.redoStorefront?.storeUrl ??
          globalThis.Shopify?.shop ??
          globalThis.Shopify?.Checkout?.apiHost
        }
      >
        <AuthenticatedShopifyExtensionClientProvider
          baseUrl={
            globalThis.redoStorefront?.env?.REDO_SHOPIFY_SERVER_URL ??
            process.env.REDO_SHOPIFY_SERVER_URL!
          }
          storeUrl={Shopify?.shop}
        >
          <RedoShopifyRpcClientContextProvider
            baseUrl={
              globalThis.redoStorefront?.env?.REDO_SHOPIFY_SERVER_URL ??
              process.env.REDO_SHOPIFY_SERVER_URL!
            }
            storeUrl={
              globalThis.Shopify?.shop ?? globalThis.Shopify?.Checkout?.apiHost
            }
            widgetId={globalThis.redoWidgetId}
          >
            <ExtensionShopifyClientContext.Provider
              value={ShopifyAjaxClient.fromEnv()}
            >
              <ConciergeProductFormShopifyWrapper settings={settings} />
            </ExtensionShopifyClientContext.Provider>
          </RedoShopifyRpcClientContextProvider>
        </AuthenticatedShopifyExtensionClientProvider>
      </RedoRoot>
    </StyleRoot>,
  );
}
